import type {
  IntermediaryAnalyticsDataResponse,
  IntermediaryAnalyticsFilters,
} from '@models/intermediaryAnalytics';
import { useQuery } from '@tanstack/react-query';
import { getIntermediaryAnalytics } from './api';

export function useIntermediaryAnalyticsQuery(
  filters: IntermediaryAnalyticsFilters,
  options?: { enabled?: boolean },
) {
  return useQuery<IntermediaryAnalyticsDataResponse>({
    queryKey: ['intermediaryAnalytics', filters],
    queryFn: () => getIntermediaryAnalytics(filters),
    staleTime: 60 * 60 * 1000, // 1 hour
    enabled: options?.enabled ?? true,
  });
}
